import userInput from './saveInputs/userInput';

export default (user) => `
    deleteUser (user: {
        ${userInput(user)}
    })
`;
